export default "__VITE_ASSET__CMrgZ72s__"